import React from 'react'
import styled from 'styled-components'
import { Grid12ColFullWidth } from '@styles/global/cssGrid'
import { device } from '@styles/global/breakpoints'
import { MissMagnolia } from '@styles/global/fonts'
import { Width } from '@utils/window'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { IProject } from '@et/types/Courses'
import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import { getVideo } from '@utils/videoUtils'

// TODO: DEPRECATED
interface IProps {
  backgroundColor: string
  reverse?: boolean
  textColor?: string
  gatsbyImage: IGatsbyImageDataObject
  gatsbyImageMobile?: IGatsbyImageDataObject | null
  videoSrc?: string
  projectImgMobile: string
  subheadColor?: string
  type: string
  title: string
  desc: string
}

function ProjectModuleOneV4({ videoSrc, backgroundColor = '#fff', reverse = false, textColor = `#000`, gatsbyImage, gatsbyImageMobile, subheadColor = '#000', type, title, desc, video }: IProps & IProject) {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Grid12ColFullWidth>
        {video && videoSrc && <ProjectImageWrapper reverse={reverse}>
          {getVideo({
            posterImg: gatsbyImage,
            videoSrc
          })}
        </ProjectImageWrapper>}
        {!video && <ProjectImageWrapper reverse={reverse}>
          {Width > 767 && <BackgroundImageV5 gatsbyDataImg={gatsbyImage.gatsbyImageData} />}
          {Width < 767 && <BackgroundImageV5
            gatsbyDataImg={gatsbyImageMobile ? gatsbyImageMobile.gatsbyImageData : gatsbyImage.gatsbyImageData} />}
        </ProjectImageWrapper>}
        <ProjectContent
          reverse={reverse}
          textColor={textColor}
          subheadColor={subheadColor}>
          <ProjectType>
            {type}
          </ProjectType>
          <ProjectTitle>
            <h3>
              {title}
            </h3>
          </ProjectTitle>
          <div>
            <p>
              {desc}
            </p>
          </div>
        </ProjectContent>
      </Grid12ColFullWidth>
    </Wrapper>
  )
}

interface IWrapperProps {
  backgroundColor: string
}

interface IDirection {
  reverse: boolean
}

interface IContent {
  textColor: string
  reverse: boolean
  subheadColor: string
}

const Wrapper = styled.div<IWrapperProps>`
  background: ${props => props.backgroundColor};
`
const ProjectImageWrapper = styled.div<IDirection>`
  min-height: 250px;
  grid-row-start: 1;
  grid-column: 2 / 4;
  display: grid;
  video{
    width: 100%;
  }
  
  @media ${device.tablet}{
    min-height: 500px;
    grid-column: 1 / -1;
  }
  
  ${props => imgLayout(props.reverse)}
  
  .gatsby-image-wrapper{
    width: 100%;
    height: 100%;
  }
  
`
const ProjectType = styled.div`
  ${MissMagnolia};
  font-size: 14px;
  text-align: center;
  
  @media ${device.tablet}{
    font-size: 18px;
  }
  @media ${device.laptop}{
    text-align: left;
  }
`
const ProjectTitle = styled.div`
  max-width: 280px;
  margin: 0 auto;
  padding: 30px 0;

  h3 {
    ${MissMagnolia};
    font-size: 40px;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    line-height: 50px;
  }
  @media ${device.tablet}{
    max-width: none;
    margin: 0;
    h3 {
      font-size: 55px;
      line-height: 65px;
    }
  }
  
  @media (min-width: 1024px){
    h3 {
      text-align: left;
    }
  }
  @media (min-width: 1200px){
    h3 {
      text-align: left;
      font-size: 60px;
      line-height: 70px;
    }
  }
  
  @media (min-width: 1600px){
    h3 {
      font-size: 70px;
      line-height: 80px;
    }
  }
`
const ProjectContent = styled.div<IContent>`
  display: grid;
  grid-auto-rows: minmax(min-content, max-content);
  grid-column: 2 / 4;
  padding: 30px;
  align-content: center;
  
  ${props => contentLayout(props.reverse)};
  
  ${ProjectType}{
    color: ${props => props.subheadColor};
  }
  
  div,  ${ProjectTitle}{
    color: ${props => props.textColor};
  }
  
`

function contentLayout(reverse: boolean) {
  if (reverse) {
    return `
      @media ${device.tablet}{
        grid-column: 1 / 6;
      }
      
      @media ${device.laptop}{
        padding: 0 18% 30px;
      }
      
      @media ${device.laptopL}{
        grid-column: 1 / 5;
        min-height: 800px;
      }
      @media ${device.desktop}{
        min-height: 1000px;
      }
    `
  }
  return `
    @media ${device.tablet}{
      grid-column: 1 / -1;
    }
    
    @media ${device.laptop}{
      grid-column: 8 / -1;
      grid-auto-rows: minmax(min-content, max-content);
      padding: 0 18% 30px;
    }
    
    @media ${device.laptopL}{
      padding: 0 18% 30px;
      min-height: 800px;
      grid-column: 9 / -1;
    }
    @media ${device.desktop}{
      min-height: 1000px;
    }
  `
}

function imgLayout(reverse: boolean) {
  if (reverse) {
    return `
    @media ${device.laptop}{
      margin-left: -30px;
      grid-column: 6 / -1;
    }
  
    @media ${device.laptopL}{
      grid-column: 5 / -1;
    }
    `
  }

  return `
    @media ${device.laptop}{
      margin-right: -30px;
      grid-column: 1 / 8;
      min-height: 650px;
    }
  
    @media ${device.laptopL}{
      grid-column: 1 / 9;
      min-height: 800px;
    }
  `
}

export default ProjectModuleOneV4
